var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome3Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9091,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 10.9091,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9091,
    y: 10.9091,
    width: 9.09091,
    height: 9.09091,
    rx: 2,
    fill: "#161E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome3Svg);
export default __webpack_public_path__ + "static/media/home3svg.e8b761b6368138cfc21cdc52f3a5f055.svg";
export { ForwardRef as ReactComponent };